import styled from 'styled-components';

export const StyledLoginWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .logo {
    margin-bottom: 20px;
  }
  .google-auth-btn {
    margin: 20px 0;
    padding: 0;
    width: 50px;
    height: 50px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledLoginFormHead = styled.div`
  padding-bottom: 20px;
  text-align: center;
  p {
    text-align: center;
  }
`;

export const StyleFormTitle = styled.div`
  color: #162954;
  font-size: 18px;
`;

export const StyledLoginFormWrapper = styled.div`
  max-width: 445px;
  width: 100%;
  margin-bottom: 45px;
  padding: 30px;
  background-color: #fff;
  border: 1px solid #EDEDED;
  border-radius: 5px;
  .login-with-google {
    text-align: center;
    //border: 1px dashed red;
    &__button {
      //background-color: orange;
      //margin: 20px 0;
      padding: 0;
      width: 50px;
      height: 50px;
      color: #162954;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 2px solid #162954;
      transition: all .3s ease;
      &:hover {
        background-color: rgba(22, 41, 84, 0.05);
      }
    }
    &__text {
      padding: 20px 0;
      text-align: center;
    }
  }
  .login-form {
    padding: 0;
    border: none;
    box-shadow: none;
    &__action {
      padding-top: 20px;
      justify-content: center;
      text-align: center;
      grid-gap: 10px;
    }
    &__input, .twofa-field-group {
      & > div {
        padding: 3px 0;
      }
      label {
       font-size: 16px;
       font-weight: 600;
      }
      input {
        font-size: 16px;
      }
      span {
        font-size: 16px;
      }
    }
    .twofa-field-group {
      margin-bottom: 30px;
    }
  }
  @media screen and (max-width: 600px) {
    padding: 20px 15px;
  }
`;
